import { View } from "@/components/ui";
import { CreditAccountTransactionTypeEnum } from "@/__generated__/graphql";
import { formatDateTime } from "@/lib/helpers/date";
import { formatPrice } from "@/lib/helpers/number";
import { cn } from "@/lib/utils";
import { UsersThree, TrayArrowUp, Receipt } from "@/components/shared/icons";
import { Typography } from "../typography";
import type { ClientCreditAccountTransaction } from "@/types/profile";

function transactionHistoryIcon({
  transactionType,
}: {
  transactionType: CreditAccountTransactionTypeEnum;
}): React.ReactNode {
  switch (transactionType) {
    case CreditAccountTransactionTypeEnum.Referral:
      return (
        <UsersThree
          size={28}
          weight="fill"
          className="text-foreground-intermediate"
        />
      );
    case CreditAccountTransactionTypeEnum.Payment:
      return (
        <Receipt
          size={28}
          weight="fill"
          className="text-foreground-intermediate"
        />
      );
    case CreditAccountTransactionTypeEnum.TopUp:
      return (
        <TrayArrowUp
          size={28}
          weight="fill"
          className="text-foreground-intermediate"
        />
      );
    default:
      return (
        <UsersThree
          size={28}
          weight="fill"
          className="text-foreground-intermediate"
        />
      );
  }
}

type Props = {
  transaction: ClientCreditAccountTransaction;
  icon?: React.ReactNode;
};

export default function TransactionHistoryCard({ transaction, icon }: Props) {
  return (
    <View
      key={transaction.id}
      className="mb-4 flex w-full flex-1 flex-row gap-2 border-b border-secondary-border p-4 pt-0 md:px-0"
    >
      {icon &&
        transactionHistoryIcon({
          transactionType: transaction.transactionType,
        })}
      <View className="flex flex-1 flex-row items-center justify-between">
        <View className="flex max-w-[200px] flex-col gap-1">
          <Typography variant="label-sm">{transaction.description}</Typography>
          {transaction.authorizedAt && (
            <Typography variant="body-sm" color="foreground-intermediate">
              {formatDateTime(
                new Date(transaction.authorizedAt),
                "d LLL y',' hh':'mm",
              )}
            </Typography>
          )}
        </View>
        <Typography
          variant="body-sm"
          className={cn(
            "",
            transaction.transactionType ===
              CreditAccountTransactionTypeEnum.Payment
              ? "text-danger"
              : "text-success",
          )}
        >
          {formatPrice(transaction.amount)}
        </Typography>
      </View>
    </View>
  );
}
